export default __webpack_public_path__ + "static/media/left-hand.05bd947e.gif";